module.exports = __webpack_public_path__ + "img/UI.e6912af2.svg";